<shared-ui-modal-base-modal
  [title]="'Upload picture'"
  [confirmButtonDisabled]="((loading$ | async) ?? false) || !selectedImage"
  [confirmButtonTitle]="(loading$ | async) ? 'Processing...' : 'Upload'"
  [closeOnConfirm]="false"
  [hasBrowseButton]="true"
  (confirmBrowseOutput)="browseFiles()"
  (confirmOutput)="uploadImage()"
>
  <input #input hidden [type]="'file'" [multiple]="false" [accept]="accept" (change)="fileChangeEvent($event)" />
  <image-cropper
    *ngIf="selectedImage"
    #cropper
    class="image-cropper"
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [autoCrop]="false"
    [roundCropper]="true"
    [allowMoveImage]="true"
    [alignImage]="'center'"
    [cropperStaticWidth]="cropperSize"
    [cropperStaticHeight]="cropperSize"
    [containWithinAspectRatio]="true"
    [hideResizeSquares]="true"
    [format]="'png'"
    [backgroundColor]="'transparent'"
    [cropper]="cropperPosition"
    [(transform)]="transform"
    (imageCropped)="imageCropped($event)"
    (loadImageFailed)="loadImageFailed()"
    (cropperReady)="cropperReady()"
    (wheel)="mouseZoom($event)"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
  ></image-cropper>
  <input *ngIf="selectedImage" class="zoom-slider" type="range" min="0.5" max="2.5" step="0.0001" [value]="transform.scale ?? 1" (input)="zoomChanged($event)" />
  <div *ngIf="!selectedImage" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" class="drop-files">Drop files to upload</div>
</shared-ui-modal-base-modal>
